<template>
  <feature-card-data-row-input
    v-bind="{ ...$props, ...$attrs }"
    :value="value"
    @input="$emit('input', $event)"
    dense
    :items="usersArray"
    :menu-props="{ offsetY: true }"
    :rules="rules"
    :data-type="dataType"
  />
</template>

<script>
import { get } from 'vuex-pathify';

import FeatureCardDataRowInput from '@/components/FeatureCardDataRowInput';

export default {
  name: 'UserSelect',
  components: {
    FeatureCardDataRowInput,
  },
  data: () => ({
    dataType: {
      name: 'select',
    },
    oldValueProxy: null,
  }),
  props: {
    value: {
      type: Number,
      default: undefined,
    },
    rules: {
      type: Array,
    },
    isEditingOn: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    relationValuesMapping: get('attributesSchema/relationValuesMapping'),
    deleteUserSufix() {
      return `(${this.$store.get('admin/modulesMapping@users.deleted_suffix')})`;
    },
    usersArray() {
      return this.relationValuesMapping['users_users']['id']['name'].filter(
        item =>
          !item.text.includes(this.deleteUserSufix) || item.value === this.oldValueProxy || item.value === this.value
      );
    },
  },
  watch: {
    isEditingOn: {
      handler(nV) {
        if (nV && this.value) this.oldValueProxy = JSON.parse(JSON.stringify(this.value));
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-list-item__title {
  text-align: left;
}
::v-deep .v-select__selection--disabled {
  color: rgba(0, 0, 0, 0.87) !important;
}
::v-deep .v-select__selection {
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
}
</style>
